import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-database-icon',
  templateUrl: 'database-icon.component.html'
})
export class DatabaseIconComponent {
  constructor() {}
}
